module.exports = __webpack_public_path__ + "img/loading-three-dots.48329505.svg";